import { EMPTY_MESSAGES } from '@/shared/lib/constants';
import { FilterDropdown } from '@/shared/ui/FilterDropdown';
import type { FilterDropdownOption } from '@/shared/ui/FilterDropdown';
import { SearchInput } from '@/shared/ui/SearchInput';

import {
  DAG_FAVORITE_FILTER_OPTIONS,
  DAG_MATURITY_FILTER_OPTIONS,
  DAG_RUN_STATUS_FILTER_OPTIONS,
} from '@/features/dag-list/lib/dagFilterOptions';
import type {
  DagFavoriteFilterValue,
  DagMaturityFilterValue,
  DagRunStatusFilterValue,
} from '@/features/dag-list/model/types';

import styles from './DagListFilters.module.css';

const renderFilterItem = <T extends string>(option: FilterDropdownOption<T>) => <span>{option.label}</span>;

type DagListFiltersProps = {
  searchQuery: string;
  selectedRunStatus: DagRunStatusFilterValue[];
  selectedFavorite: DagFavoriteFilterValue[];
  selectedMaturity: DagMaturityFilterValue[];
  selectedTags: string[];
  dagTagOptions: FilterDropdownOption<string>[];
  isDagTagOptionsLoading?: boolean;
  onSearchChange: (value: string) => void;
  onRunStatusFilterChange: (values: DagRunStatusFilterValue[]) => void;
  onFavoriteFilterChange: (values: DagFavoriteFilterValue[]) => void;
  onMaturityFilterChange: (values: DagMaturityFilterValue[]) => void;
  onTagFilterChange: (values: string[]) => void;
};

const getButtonTextForSingleSelection = <T extends string | number>(options: FilterDropdownOption<T>) => {
  if (options.value === 'all') return '전체';
  return options.label;
};

export const DagListFilters = ({
  searchQuery,
  selectedRunStatus,
  selectedFavorite,
  selectedMaturity,
  selectedTags,
  dagTagOptions,
  isDagTagOptionsLoading = false,
  onSearchChange,
  onRunStatusFilterChange,
  onFavoriteFilterChange,
  onMaturityFilterChange,
  onTagFilterChange,
}: DagListFiltersProps) => {
  return (
    <div className={styles.toolbar}>
      <div className={styles.filterSection}>
        <FilterDropdown<DagRunStatusFilterValue>
          buttonText="Status"
          searchPlaceholder=""
          selectedValues={selectedRunStatus}
          options={DAG_RUN_STATUS_FILTER_OPTIONS}
          onSelectionChange={onRunStatusFilterChange}
          renderItem={renderFilterItem}
          getButtonTextForSingleSelection={getButtonTextForSingleSelection}
          mode="single"
          width={118}
          showSearch={false}
        />
        <FilterDropdown<string>
          width={278}
          buttonText="Tag"
          searchPlaceholder="태그 검색"
          selectedValues={selectedTags}
          options={dagTagOptions}
          emptyDescription={EMPTY_MESSAGES.NO_DAG_TAG_OPTIONS}
          onSelectionChange={onTagFilterChange}
          renderItem={renderFilterItem}
          mode="multiple"
          disabled={isDagTagOptionsLoading}
        />
        <FilterDropdown<DagMaturityFilterValue>
          buttonText="Maturity"
          searchPlaceholder=""
          selectedValues={selectedMaturity}
          options={DAG_MATURITY_FILTER_OPTIONS}
          onSelectionChange={onMaturityFilterChange}
          renderItem={renderFilterItem}
          getButtonTextForSingleSelection={getButtonTextForSingleSelection}
          mode="single"
          width={120}
          showSearch={false}
        />
        <FilterDropdown<DagFavoriteFilterValue>
          buttonText="Favorites"
          searchPlaceholder=""
          selectedValues={selectedFavorite}
          options={DAG_FAVORITE_FILTER_OPTIONS}
          onSelectionChange={onFavoriteFilterChange}
          renderItem={renderFilterItem}
          getButtonTextForSingleSelection={getButtonTextForSingleSelection}
          mode="single"
          width={120}
          showSearch={false}
        />
      </div>
      <SearchInput
        value={searchQuery}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="DAG 이름 또는 설명으로 검색"
      />
    </div>
  );
};
